import Luminous, {LuminousGallery} from 'luminous-lightbox';
import Swiper, {Navigation, Autoplay} from "swiper";

Swiper.use([Navigation, Autoplay]);

export default class Property {

    constructor() {
        if (document.getElementById('property')) {
            this.highlights();
            this.readmore();
            this.tabs();
            this.luminous();
            this.initMap();
            this.photos();
        }
    }

    highlights() {
        const swiper = new Swiper('#highlights .swiper-container', {
            spaceBetween: 15,
            sliderPerView: 1,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
            }
        });
    }

    readmore() {
        const expandableContents = document.querySelectorAll('.expandable-content');

        expandableContents.forEach((item) => {
            item.nextElementSibling.addEventListener('click', (event) => {
                event.preventDefault();
                item.classList.add('active');
                item.nextElementSibling.style.display = 'none';
            })
        })
    }

    tabs() {
        const links = document.querySelectorAll('.tabLink');
        const tabs = document.querySelectorAll('#media .tab');
        links[0].classList.add('active');
        tabs[0].classList.add('active');
        links.forEach(function (el, i) {
            el.addEventListener('click', function (ev) {
                ev.preventDefault();

                tabs.forEach(function (tab) {
                    tab.classList.remove('active');
                });

                links.forEach(function (link) {
                    link.classList.remove('active');
                });

                let item = document.querySelector(el.getAttribute('href'));
                this.classList.add('active');
                item.classList.add('active');
            });
        });
    }

    luminous() {
        new LuminousGallery(document.querySelectorAll('.luminous'));
    }

    initMap() {
        if (document.getElementById("maps")) {
            let bounds = new google.maps.LatLngBounds();
            const maps = document.getElementById("maps");

            const map = new google.maps.Map(maps, {
                zoom: 18,
                mapTypeId: google.maps.MapTypeId.SATELLITE, // Use satellite imagery
                center: new google.maps.LatLng(maps.dataset.lat, maps.dataset.lon),
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#444444"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#b4d4e1"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            });

            const icon = {
                url: "/img/icon-map.png", // url
                scaledSize: new google.maps.Size(44, 44), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(22, 22) // anchor
            };

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(maps.dataset.lat, maps.dataset.lon),
                map: map,
                icon: icon
            });
        }
    }

    photos() {
        const allPhotos = document.getElementById('allPhotos')
        const photosTab = document.getElementById('photosTab');

        allPhotos.addEventListener('click', e => {
            e.preventDefault();

            photosTab.querySelector('a').click();
        });

    }

}
